import { Component } from "@angular/core";
var TooltipContent = (function () {
    function TooltipContent() {
    }
    return TooltipContent;
}());
export { TooltipContent };
TooltipContent.decorators = [
    { type: Component, args: [{
                selector: "clr-tooltip-content",
                template: "\n        <ng-content></ng-content>\n    "
            },] },
];
/** @nocollapse */
TooltipContent.ctorParameters = function () { return []; };
//# sourceMappingURL=tooltip-content.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/popover/tooltip/tooltip-content.js
// module id = 209
// module chunks = 4